import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getUtmParamsForQrCodeUrl } from '../../helpers';
import { getAsset } from '../../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../../hooks/useComponentSize';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
};
const BusinessCardBack = ({ albumFolder, ...props }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  return (
    <div
      className="marketing-material-business-card marketing-material-business-card-back"
      {...props}
    >
      {albumFolder?.join_code && (
        <div className="marketing-material-business-card-back-join-code">
          <strong>or</strong>
          <br />
          Text this code to 735-343:
          <br />
          <span className="text-uppercase">{albumFolder.join_code}</span>
        </div>
      )}
      <div className="marketing-material-business-card-back-qr">
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: albumFolder.is_web_gallery
              ? 'https://waldophotos.com/galleries'
              : albumFolder.onboarding_short_url,
            albumFolder,
          })}
          size={width * 0.27 ?? 100}
        />
      </div>
      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_BUSINESS_CARD_GENERAL.png',
        )}
        alt=""
      />
    </div>
  );
};

BusinessCardBack.propTypes = propTypes;

export default BusinessCardBack;
